import { B2bMarketPriceModel } from "./models/b2bMarketPrice";
import { GenderModel } from "./models/gender";
import { ImportFileHeaderModel } from "./models/importFileHeader";
import { OfferModel } from "./models/offer";
import { OrganisationModel } from "./models/organisation";
import { PersonModel } from "./models/person";
import { PriceModel } from "./models/price";
import { RegionModel } from "./models/region";
import { SellerModel } from "./models/seller";
import { SupplierModel } from "./models/supplier";
import { UploadModel } from "./models/upload";
import { UploadStatusModel } from "./models/uploadStatus";
import { UploadTypeModel } from "./models/uploadType";
import { UploadVisibilityTypeModel } from "./models/uploadVisibilityType";
import { UserAccountModel } from "./models/userAccount";
import { UserOrganisationModel } from "./models/userOrganisation";
import { VatTaxModel } from "./models/vatTax";
import { VintageModel } from "./models/vintage";
import { VintageProductModel } from "./models/vintageProduct";
import { WineModel } from "./models/wine";
import { WineryModel } from "./models/winery";
import { WineTypeModel } from "./models/wineType";

// transformers from models to dto
import { createB2BMarketPriceDtoFromAnalyticB2BMarketPriceModel } from "./models/b2bMarketPrice";
import { createOfferDtoFromAnalyticOfferModel } from "./models/offer";
import { createOrganisationDtoFromAnalyticOrganisationModel } from "./models/organisation";
import { createPriceDtoFromAnalyticPriceModel } from "./models/price";
import { createRegionDtoFromAnalyticRegionModel } from "./models/region";
import { createSellerDtoFromAnalyticSellerModel } from "./models/seller";
import { createSupplierDtoFromAnalyticSupplierModel } from "./models/supplier";
import { createVatTaxDtoFromAnalyticVatTaxModel } from "./models/vatTax";
import { createVintageDtoFromAnalyticVintageModel } from "./models/vintage";
import { createVintageProductDtoFromAnalyticVintageProductModel } from "./models/vintageProduct";
import { createWineDtoFromAnalyticWineModel } from "./models/wine";
import { createWineryDtoFromAnalyticWineryModel } from "./models/winery";
import { createWineTypeDtoFromAnalyticWineTypeModel } from "./models/wineType";

export {
  B2bMarketPriceModel,
  GenderModel,
  ImportFileHeaderModel,
  OfferModel,
  OrganisationModel,
  PersonModel,
  PriceModel,
  RegionModel,
  SellerModel,
  SupplierModel,
  UploadModel,
  UploadStatusModel,
  UploadTypeModel,
  UploadVisibilityTypeModel,
  UserAccountModel,
  UserOrganisationModel,
  VatTaxModel,
  VintageModel,
  VintageProductModel,
  WineModel,
  WineryModel,
  WineTypeModel,

  // transformers from models to dto
  createB2BMarketPriceDtoFromAnalyticB2BMarketPriceModel,
  createOfferDtoFromAnalyticOfferModel,
  createOrganisationDtoFromAnalyticOrganisationModel,
  createPriceDtoFromAnalyticPriceModel,
  createRegionDtoFromAnalyticRegionModel,
  createSellerDtoFromAnalyticSellerModel,
  createSupplierDtoFromAnalyticSupplierModel,
  createVatTaxDtoFromAnalyticVatTaxModel,
  createVintageDtoFromAnalyticVintageModel,
  createVintageProductDtoFromAnalyticVintageProductModel,
  createWineDtoFromAnalyticWineModel,
  createWineryDtoFromAnalyticWineryModel,
  createWineTypeDtoFromAnalyticWineTypeModel,
};
